<template>
  <div class="hm-upgrade-lock d-flex d-flex align-items-center">
    <HMInfoPopover
      placement="bottom"
      size="medium"
      target="upgrade-trigger"
      desktopTriggers="hover blur"
    >
      <div
        class="upgrade-popover d-flex flex-column justify-content-center align-items-center text-center"
      >
        <img src="/assets/images/rocket.svg" />
        <h4 class="mt-3">
          {{ $t(text) }}
        </h4>
        <HMButton
          class="mt-4"
          color="brand"
          @click="$router.push({ name: 'settings-adjust-plan' })"
        >
          {{ $t('GENERAL.BUTTON.UPGRADE_NOW') }}
        </HMButton>
      </div>
    </HMInfoPopover>
    <div id="upgrade-trigger">
      <i class="far fa-lock-alt"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMUpgradeLock',
  props: {
    text: {
      type: String,
      default: 'GENERAL.TEXT.FEATURE_NOT_AVAILABLE_ON_THIS_PLAN_UPGRADE',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.upgrade-icon {
  height: 24px;
}

.upgrade-popover {
  padding: 2rem;
  background-color: lighten($coral, 30%);
}

#upgrade-trigger {
  background-color: $coral;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  font-size: 1.2rem;
  cursor: pointer;
}

h4 {
  font-weight: 500;
}
</style>
